import { api } from './api';

export interface LoginData { email: string; password: string }
export interface RegisterData {
  full_name: string; email: string; password: string;
  working_days?: string[]; daily_hours?: number; timezone?: string;
  invitation_token?: string;
}

export const authService = {
  register: (data: RegisterData) => api.post('/auth/register', data),
  login: (data: LoginData) => api.post('/auth/login', data),
  logout: () => api.post('/auth/logout'),
  refreshToken: () => api.post('/auth/refresh'),
  getMe: () => api.get('/auth/me'),
  updateProfile: (data: Partial<RegisterData>) => api.patch('/auth/me', data),
  changePassword: (data: { current_password: string; new_password: string }) =>
    api.patch('/auth/me/password', data),
  forgotPassword: (data: { email: string }) => api.post('/auth/forgot-password', data),
  resetPassword: (data: { token: string; password: string }) => api.post('/auth/reset-password', data),
  verifyEmail: (data: { token: string }) => api.post('/auth/verify-email', data),
  resendVerification: (data: { email: string }) => api.post('/auth/resend-verification', data),
  getInvitationInfo: (token: string) => api.get('/auth/invitation-info', { params: { token } }),
  acceptInvitation: (token: string) => api.post('/onboarding/accept-invitation', { token }),
};
